import { defineNuxtPlugin } from '#app'

const getFormatedPhoneNUmber = (phoneNumber: string): string => {
    const baseOfnumber = phoneNumber.replaceAll(' ', '')
    const prefix = baseOfnumber.slice(0, 4)
    const suffix = baseOfnumber.slice(4, phoneNumber.length)
    return `${prefix} 
    ${suffix.slice(0, 3)} ${suffix.slice(3, 6)} ${suffix.slice(
        6,
        phoneNumber.length
    )}`
}

export default defineNuxtPlugin(() => {
    return {
        provide: {
            phoneNumber: (phoneNumber: string) =>
                getFormatedPhoneNUmber(phoneNumber),
        },
    }
})
